<template>

        <v-select


                prepend-icon="account_tree"
                :items="getItems"
                v-model="item"
                :label="$t('delivery.order.labels.state')"
                :loading="loading"
                :error="hasInputErrors('state')"
                :error-messages="getInputErrors('state')"
                color="secondary"
                item-color="secondary"

                :clearable="clearable"
                :multiple="multiple"
                :chips="chips"
                :solo="solo"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'



    export default {
        name: "OrderStateCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {type: [String, Array]},
            clearable: {type:Boolean, default: false},
            multiple: {type:Boolean, default: false},
            solo: {type:Boolean, default: false},
            chips: {type:Boolean, default: false}
        },
        data() {
            return {
                items: ['PENDING_RECEIPT','REVIEW','NEW','PREPARING','READY','ON_THE_WAY','DELIVERED','CANCELED'],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            },
          getItems(){
             return this.items.map(state => ({text: this.$t('delivery.states.'+state) , value: state}))
          }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        }
    }
</script>

<style scoped>

</style>

